import React, { Component } from 'react';
import config from '../../../config';
import { formatUrlForCdn, updateSrcSetForCdn } from '../../utils/url';

class Img extends Component {
    constructor(props) {
        super(props);
        this.setImgRef = this.setImgRef.bind(this);
        this.image = React.createRef();
    }

    setImgRef(img) {
        this.image = img;
        const { onImgLoad } = this.props;
        if (this.image && onImgLoad) {
            this.image.addEventListener('load', onImgLoad(this.image));
            if (this.image.complete) {
                onImgLoad(this.image);
            }
        }
    }

    render() {
        const { cdnUrl } = config;
        const { onImgLoad, noCdn, srcSet, defaultimg, src, useRawSrcSet, ...rest } = this.props;
        const useCdn = cdnUrl && !noCdn;
        let finalSrcSet;
        let finalSrc;
        if (useCdn) {
            if (srcSet) {
                finalSrcSet = useRawSrcSet ? srcSet : updateSrcSetForCdn(srcSet, cdnUrl);
            }
            finalSrc = cdnUrl && src ? formatUrlForCdn(cdnUrl, src) : '';
        } else {
            finalSrc = src || '';
            finalSrcSet = srcSet || '';
        }

        return (
            <img
                {...rest}
                src={finalSrc}
                srcSet={finalSrcSet}
                ref={el => this.setImgRef(el)}
                onError={(e) => {
                    if (defaultimg) {
                        // Detach handler so a failing defaultimg doesn't refetch in a loop.
                        e.target.onerror = null;
                        e.target.src = `${defaultimg}`;
                        e.target.srcset = `${defaultimg}`;
                    }
                }}
            />
        );
    }
}

export default Img;
